import React from 'react';

export const RatingSummaryModal = React.lazy(() =>
  import('./RatingSummaryModal/RatingSummaryModal').then((m) => ({ default: m.RatingSummaryModal })),
);
export const TotalInsurableValueModal = React.lazy(() =>
  import('./TotalInsurableValueModal/TotalInsurableValueModal').then((m) => ({ default: m.TotalInsurableValueModal })),
);
export const KYTaxSurchargeModal = React.lazy(() =>
  import('./KYTaxSurchargeModal/KYTaxSurchargeModal').then((m) => ({ default: m.KYTaxSurchargeModal })),
);
